import { useEffect } from 'react';

const SITE_NAME = 'Jouw Noodpakket.nl';
const SITE_URL = 'https://noodpakket.nl';
const DEFAULT_DESCRIPTION = 'Bouw jouw persoonlijke noodpakket voor elke crisis. Vergelijk de beste producten voor noodsituaties in Nederland — water, EHBO, verlichting, communicatie en meer.';
const DEFAULT_OG_IMAGE = 'https://images.pexels.com/photos/11182954/pexels-photo-11182954.jpeg';

function setMeta(name, content, isProperty = false) {
  if (!content) return;
  const key = isProperty ? 'property' : 'name';
  let el = document.head.querySelector(`meta[${key}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function setJsonLd(id, data) {
  let el = document.head.querySelector(`script[data-jsonld="${id}"]`);
  if (data == null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement('script');
    el.setAttribute('type', 'application/ld+json');
    el.setAttribute('data-jsonld', id);
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/**
 * Sets <title>, description, canonical, and OpenGraph/Twitter tags.
 * Call once per page; it updates in place.
 */
export function useSEO({ title, description, image, path, type = 'website', jsonLd } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} — bouw jouw noodpakket voor elke situatie`;
    const desc = description || DEFAULT_DESCRIPTION;
    const img = image || DEFAULT_OG_IMAGE;
    const url = `${SITE_URL}${path || (typeof window !== 'undefined' ? window.location.pathname : '/')}`;

    document.title = fullTitle;
    setMeta('description', desc);
    setLink('canonical', url);

    // OpenGraph
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', desc, true);
    setMeta('og:image', img, true);
    setMeta('og:url', url, true);
    setMeta('og:type', type, true);
    setMeta('og:site_name', SITE_NAME, true);
    setMeta('og:locale', 'nl_NL', true);

    // Twitter
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', desc);
    setMeta('twitter:image', img);

    // JSON-LD (structured data)
    setJsonLd('page', jsonLd || null);
  }, [title, description, image, path, type, JSON.stringify(jsonLd)]);
}
